angular.module('routes.cases.widgets.WidgetsPayloadResolver', [
  'stack'
])

/**
 * The WidgetsPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class WidgetsPayloadResolver
 * @constructor
 * @module routes.cases.widgets.WidgetsPayloadResolver
 */
.factory('WidgetsPayloadResolver', [
  'GLOBAL',
  'ModelsService',
  function (GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      if (params.widgetId && params.widgetId !== 'events' && params.widgetId !== 'sbar') {
        return ModelsService.get('widgets', GLOBAL.apiPath + '/widgets', { id: params.widgetId });
      }
      return {};
    };
  }
]);
